import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import {Container} from '../styles/Grids';
import {breakPoint} from '../styles/var';
import {categories, posts, handlerCategoriesMap} from '../data';
import Card from '../components/Card';
import ModelProvider from '../components/modalContext';
import VoteModal from '../components/VoteModal';
import clsx from 'clsx';
import {getRecord} from '../api/voteApi';

const categoriesMap = handlerCategoriesMap();

const ContentStyles = styled.div`
  .container {
    padding: 4rem 2rem;
  }
  .list {
    text-align: left;
  }
  
  @media (min-width: ${breakPoint.min}) {
    .container {
      padding-top: 8rem;
    }
    .desc {
      width: 84%;
      margin-right: auto;
      margin-left: auto;
    }
  }
  @media (max-width: ${breakPoint.smMax}) {
    .container {
    }
  }
`;

const TagStyle = styled.button`
  color: var(--black);
  --bg: var(--primary);
  background-color: var(--bg);
  padding: .4rem 1rem;
  opacity: .3;

  &.active, &:hover {
    opacity: 1;
  }

  &::before {
    content: '#';
    margin-right: .4rem;
  }
`;
const TagGridStyles = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1rem;
`;
const PostsGridStyles = styled.div`
  display: grid;
  --column: repeat(2, 1fr);
  --gap: 3rem 2rem;
  grid-template-columns: var(--column);
  gap: var(--gap);

  @media (min-width: ${breakPoint.min}) {
    --column: repeat(4, 1fr);
    margin-top: 6rem;
  }
  @media (min-width: ${breakPoint.lgMin}) {
    --gap: 4rem 3rem;
    --column: repeat(5, 1fr);
  }
`;
const Section2 = (props) => {
  const [state, setState] = useState({
    isShow: false,
    voteId: 0,
  })
  const [filter, setFilter] = useState({
    current: 'all',
    data: posts,
  });
  const [voteMap, setVoteMap] = useState({});
  const handleShowModal = (show: true, id: 0) => {
    if(Date.now() > 1630598399999) {
      alert('投票截止囉！感謝您的參與，抽獎結果將於9/11 18:00前公布於媽媽寶寶官網-得獎公告');
    } else {
      setState({
        isShow: show,
        voteId: id
      })
    }

  }
  const handleCategory = (id) => {
    let data;
    if (id === 'all') {
      data = posts
    } else {
      data = posts.filter(({categoryId}) => categoryId === id);
    }

    setFilter({
      current: id,
      data
    });
  }
  const getRecordApi = async () => {
    const record = await getRecord();
    const recordMap = {};
    if (record.data.length > 0) {
      record.data.forEach(item => {
        recordMap[item.id] = item.votes;
      })
    }
    setVoteMap(recordMap);
  }
  useEffect(() => {
    getRecordApi();
  }, [])
  return (
    <ModelProvider value={{...state, handleShowModal}}>
      <ContentStyles {...props}>
        <Container className="container center">
          <h3 className="title">社群風格家庭票選</h3>
          <TagGridStyles>
            {categories.map(({text, id}) => <TagStyle key={id} id={id} className={clsx({active: filter.current === id})} onClick={() => handleCategory(id)}>{text}</TagStyle>)}
          </TagGridStyles>
          <div className="desc">
            <p>每個家庭都有屬於自己的風格，看到親子網紅的日常，總不自覺嘴角上揚，感同身受；媽媽寶寶遴選出2021年最受歡迎的32組社群風格家庭，快來為喜歡的風格家庭投下一票！</p>
            <ul className="list">
              <li>每組信箱每日一票不得重複投票</li>
              <li>投票就有機會把風格好禮帶回家(詳情請見媽媽寶寶粉絲專頁)</li>
              <li>可透過下方「分享」鍵幫喜歡的社群風格家庭拉票唷！</li>
            </ul>
          </div>
          <PostsGridStyles key={filter.current} className="animate__animated animate__fadeInUp animate__faster">
            {filter.data.map(item => {
              const _vote = voteMap.hasOwnProperty(item.id) ? voteMap[item.id] : 0;
              return <Card
                        key={item.id}
                        info={item}
                        vote={_vote}
                        category={categoriesMap[item.categoryId]}
                        handleShowModal={() => handleShowModal(true, item.id)}
                      />
            })}
          </PostsGridStyles>
          <VoteModal getRecordApi={getRecordApi}/>
        </Container>
      </ContentStyles>
    </ModelProvider>

  )
};

export default Section2;
